import type { BasicStylistFragment } from '@drycut/graphql';

import { Para } from '@drycut/ui-components';
import { formatStylistNames } from '@drycut/ui-format-utils';

type Props = {
  stylists: Array<BasicStylistFragment>;
} & React.ComponentProps<typeof Para>;

export function StylistList({ stylists = [], ...props }: Props): React.ReactElement {
  const names = stylists.map((stylist) => stylist.name);

  return (
    <Para {...props}>
      Stylisten im Salon: <strong className="font-aribaubold">{formatStylistNames(names)}</strong>
    </Para>
  );
}
